module.exports = __webpack_public_path__ + "static/media/Group1.12ab7f38.svg";